module.exports = __webpack_public_path__ + "static/img/vuvanhue.d3fb6b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vuvanhue.png
// module id = encr
// module chunks = 1